module.exports = __webpack_public_path__ + "static/media/header-logo.3e305acb.png";